export const DEFAULT_TOOLTIP_CONTENT_CATEGORY_KEY = 'charting' as const;
export const DEFAULT_TOOLTIP_CONTENT_PARENT_COMPONENT_KEY = 'chartBase' as const;
export const DEFAULT_TOOLTIP_CONTENT_COMPONENT_KEY = 'defaultTooltipContent' as const;
